import axios from 'axios'
import Constantes from '../../utils/constantes'

const state = {
    mensagem: "",
    mensagens: [],
    resposta: "",
    temMensagem: false,
    msgsNovas: false,
    countMsg: '',
}

// getters
const getters = {
    mensagem (state) {
        return state.mensagem
    },
    mensagens (state) {
        return state.mensagens
    },
    ultimamsg (state) {
        return state.mensagens.length > 0 ? state.mensagens[state.mensagens.length - 1].chtIntCod : -1
    },
    temMensagem (state) {
        return state.temMensagem
    },
    msgsNovas (state) {
        return state.msgsNovas
    },
    countMsg (state) {
        return state.countMsg
    },
}

// actions
const actions = {
    postarMensagem ({ commit, dispatch }, payload) {
        // console.log('postarMensagem', payload)
        commit('core/setLoading', true, { root: true })
        commit('core/clearError', null, { root: true })
        axios({
            method: 'POST',
            // url: Constantes.URL_SERVIDOR + '/chat/save',
            url: Constantes.URL_SERVIDOR_IS + '/chat/save',
            data: payload
        }).then(
            result => {
                if (result.data !== '') {
                    // console.log('postarMensagem', result.data)
                    commit('addMensagem', result.data);
                } else {
                    commit('core/setError', { message: 'Erro ao postar mensagem.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                console.error(error)
                commit('core/setLoading', false, { root: true })
                commit('core/setError', error, { root: true })
            }
        )
    },
    carregarMensagens ({ commit }, payload) {
        // console.log("carregar mensagem", payload)
        commit('setMensagens', [])
        // console.log(`${Constantes.URL_SERVIDOR}/chat/cliente?cliIntCod=${payload}`)
        commit('core/clearError', null, { root: true })
        commit('core/setLoading', true, { root: true })
        axios({
            method: 'GET',
            // url: `${Constantes.URL_SERVIDOR}/chat/cliente?cliIntCod=${payload}`
            url: `${Constantes.URL_SERVIDOR_IS}/chat/cliente/${payload}`
        }).then(
            result => {
                // console.log('carregarMensagens => result.data', result.data)
                if (result.data !== '') {
                    commit('setMensagens', result.data)
                } else {
                    commit('core/setError', { message: 'Erro ao carregar Mensagens.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    },
    carregarMensagensNovas ({ commit }, payload) {
        // console.log("carregar carregarMensagensNovas", payload)
        // console.log(`${Constantes.URL_SERVIDOR}/chat/novasmsgs?cliIntCod=${payload.cliIntCod}&chtIntCod=${payload.chtIntCod}`)
        commit('core/clearError', null, { root: true })
        commit('core/setLoading', true, { root: true })
        axios({
            method: 'GET',
            // url: `${Constantes.URL_SERVIDOR}/chat/novasmsgs?cliIntCod=${payload.cliIntCod}&chtIntCod=${payload.chtIntCod}`
            url: `${Constantes.URL_SERVIDOR_IS}/chat/novasmsgs/${payload.cliIntCod}/${payload.chtIntCod}`
        }).then(
            result => {
                //  console.log('carregarMensagensNovas => result.data', result.data)
                if (result.data !== '') {
                    commit('addMensagens', result.data)
                } else {
                    commit('core/setError', { message: 'Erro ao carregar Mensagens.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    },
    setDataLeituraMensagens ({ commit }, payload) {
        // console.log(`${Constantes.URL_SERVIDOR}/chat/savedate?cliIntCod=${payload.cliIntCod}&chtIntCod=${payload.chtIntCod}`)
        commit('core/clearError', null, { root: true })
        commit('core/setLoading', true, { root: true })
        axios({
            method: 'GET',
            // url: `${Constantes.URL_SERVIDOR}/chat/savedate?cliIntCod=${payload.cliIntCod}&chtIntCod=${payload.chtIntCod}`
            url: `${Constantes.URL_SERVIDOR_IS}/chat/savedate/${payload.cliIntCod}/${payload.chtIntCod}`
        });
    },
    verificarMensagensNovas ({ commit }, payload) {
        commit('core/clearError', null, { root: true })
        commit('core/setLoading', true, { root: true })
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR_IS}/chat/temnovidade/${payload.cliIntCod}`
        }).then(
            result => {
                //  console.log('verificarMensagensNovas => result.data', result)
                if (result.data !== '') {
                    commit('setTemMensagens', result.data)
                } else {
                    commit('core/setError', { message: 'Erro ao carregar Mensagens.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    },
    removerNovidadeMensagensNova ({ commit }, payload) {
        commit('core/clearError', null, { root: true })
        commit('core/setLoading', true, { root: true })
        axios({
            method: 'GET',
            url: `${Constantes.URL_SERVIDOR_IS}/chat/removenovidade/${payload.cliIntCod}`
        }).then(
            result => {
                //  console.log('verificarMensagensNovas => result.data', result)
                if (result.data !== '') {
                    commit('setTemMensagens', { root: false })
                } else {
                    commit('core/setError', { message: 'REMOVER.' }, { root: true })
                }
                commit('core/setLoading', false, { root: true })
            },
            error => {
                console.error(error)
                commit('core/setError', error, { root: true })
                commit('core/setLoading', false, { root: true })
            }
        )
    },
    mensagensNova ({ commit }, payload) {
        commit('setMensagemNova', payload)
    },
    contadorMsg({commit}, payload) {
        commit('setCountMsg', payload)
        
    }
}

// mutations
const mutations = {
    setMensagem (state, payload) {
        state.mensagem = payload
    },
    setMensagens (state, payload) {
        // console.log("setMensagens", payload.length > 0 ? payload[payload.length - 1].chtIntCod : -1)
        state.ultimamsg = payload.length > 0 ? payload[payload.length - 1].chtIntCod : -1
        state.mensagens = payload
    },
    addMensagens (state, payload) {
        // console.log('addMensagens', payload, payload.length > 0);
        if (payload.length > 0) {
            // console.log('entrou addMensagens', state.mensagens, payload);
            state.mensagens = state.mensagens.concat(payload)
            // console.log('saiu addMensagens', state.mensagens);
            state.mensagens = state.mensagens.filter((v, i, a) => a.findIndex(t => (t.chtIntCod === v.chtIntCod)) === i)
            let msg = state.mensagens
            msg.forEach(m => {
                if (!m.hasOwnProperty("chtDtmLeitura") && 'C' === m.chtQuemEnviou) {
                    m.chtDtmLeitura = new Date();
                }
            });
            state.mensagens = msg;
            // console.log('saiu addMensagens2', state.mensagens);

        }
    },
    addMensagem (state, payload) {
        // console.log('addMensagem', payload);
        state.mensagens.push(payload)
    },
    setTemMensagens (state, payload) {
        state.temMensagem = payload
    },
    setSemMensagens (state) {
        state.temMensagem = false
    },
    setMensagemNova(state, payload) {
        state.msgsNovas = payload
    },
    setCountMsg(state, payload) {
        state.countMsg = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
